import * as React from "react";
import {API} from "aws-amplify";
import {Loader} from "@googlemaps/js-api-loader";
import {MutableRefObject} from "react";


type AutocompleteService = google.maps.places.AutocompleteService;
type Geocoder = google.maps.Geocoder;

export interface Services {
    autocomplete: MutableRefObject<AutocompleteService | null>,
    geocoder: MutableRefObject<Geocoder | null>
}

const GoogleMapsServices = () => {
    const services: Services = {
        autocomplete: React.useRef<AutocompleteService | null>(null),
        geocoder: React.useRef<Geocoder | null>(null)
    };

    React.useEffect(() => {
        const loadKey = async (): Promise<string> => {
            //FIXME (mmilburn): Should this live under a different API?
            return await API.get("hqs", "/ssm/GMAPS_KEY", {});
        };

        loadKey().then((key) => {
            const loader = new Loader({
                    apiKey: key,
                    libraries: ["places"],
                }
            );
            loader.load().then((google) => {
                services.autocomplete.current = new google.maps.places.AutocompleteService();
                services.geocoder.current = new google.maps.Geocoder();
            });
        });
    }, [services.autocomplete, services.geocoder]);
    return services;
};

export default GoogleMapsServices;